import {createSlice} from '@reduxjs/toolkit';

export const defaultProjectTitle = 'Untitled Project';
interface ProjectState {
  name: string;
  modified: string;
  path: string;
  newProject: boolean;
  configVersion: string;
}

// Current config version
export const currentConfigVersion = "3.11.0";

// Not possible to upgrade below this version
export const minimumConfigVersion = "3.4.0";

export const projectSlice = createSlice({
  name: 'project',
  initialState: {
    path: '',
    newProject: true,
    name: defaultProjectTitle,
    modified: new Date().toISOString(),
    configVersion: currentConfigVersion
  } as ProjectState,
  reducers: {
    refreshModified: (state, action) => {
      state.modified = new Date().toISOString();
    },
    changeName: (state, action) => {
      state.name = action.payload;
    },
    changePath: (state, action) => {
      state.path = action.payload;
    }
  }
});

export const {
  refreshModified,
  changeName,
  changePath
} = projectSlice.actions;

export default projectSlice.reducer;

export const selectName = state => state.project.name;
export const selectProjectModified = state => state.project.modified;